// removed by extract-text-webpack-plugin
module.exports = {"performance-list-item":"_3ThnOrQRE _2l0xl0HVf _2piomsVWh","time":"_3iAs3RQM5 _2l0xl0HVf _38fsqHPnh _1vgzIe30_ _3QfjnbU8u _36G1vXKEz AGCUd9FD4","meta":"_2ZTxbDkWz _2l0xl0HVf _1yJuXbiru _1FTxuUfut _13qojEuKg _1BE2U7F8v _2tvY6e7Hw djpnYa4K-","arrow":"_2c-7uXN5c _2gtf48bQr _3EiT4eWlg _2Kz2o9zH0 _3nN4OpP4I _2FRZ4UhUt _2tvY6e7Hw _3oZepBe3o"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/performance-list-item/performance-list-item.css
 ** module id = 2146
 ** module chunks = 0
 **/